<template>
  <div class="download-link">
    <a
      target="_blank"
      :href="downloadLinkPath"
      class="download-link-container"
      data-track-as="downloadlink"
    >
      <div class="download-link-text">
        <slot name="text"></slot>
      </div>
      <div class="download-link-icon">
        <dotcom-icon name="circle-arrow-down" art="light" />
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'SanitasMagazineDownloadLink',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    downloadLinkPath: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="postcss">
div.download-link {
  sup {
    top: -0.2em !important;
  }
  a.download-link-container {
    text-decoration: none;
    display: flex;
    font-size: 15px;
    color: var(--c-primary-neutral-1);
    text-align: left;
    position: relative;
    border-bottom: 1px solid var(--c-primary-neutral-1);
    border-top: 1px solid var(--c-primary-neutral-1);
    margin-bottom: 40px;
    align-items: center;
    &:hover {
      text-decoration: none;
      border-bottom: 1px solid var(--c-primary-neutral-1);
      .download-link-text {
        color: var(--c-primary-color-3);
      }
      .download-link-icon {
        span {
          fill: var(--c-primary-color-3);
        }
      }
    }
  }
  &-text {
    padding: 20px 0;
    font-weight: normal;
  }

  &-icon {
    margin: auto 0px auto auto;
  }
}
</style>

<style lang="postcss" scoped>
.download-link-icon >>> .dotcom-icon {
  font-size: 30px;
}
</style>
